export default __webpack_public_path__ + "static/media/not-found.c8c111db.png";